




import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    mediaEntry: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
});
